import { useState, useEffect, useRef } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import DraggableElement from "./DraggableElement";
import { InputAdornment, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import Popup from "../../../../../Base/views/Popup";
import AtsCandidatePreview from "../../AtsCandidatePreview";
import {
  AddAtsJobKanbanHelper,
  AddAtsJobKanbanOfferHelper,
  GetAtsJobKanbanHelper,
  GetAtsJobKanbanOfferHelper,
  UpdateAtsJobKanbanHelper,
  UpdateAtsJobKanbanOfferHelper,
} from "../../../../helper/AtsJobKanbanHelper";
import {
  AddAtsJobStageHelper,
  DeleteAtsJobStageHelper,
  GetAtsJobStageHelper,
  UpdateAtsJobStageHelper,
} from "../../../../helper/AtsJobStageHelper";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAtsCandidateAction,
  ProposeCandidateConfirmationAction,
} from "../../../../../../../store/ATS/Candidate/Action";
import { matchSorter } from "match-sorter";
import CommonDatePicker from "../../../../../Base/views/CommonDatePicker";
import AtsCandidateValidate from "../../../ATSCandidate/AtsCandidateValidate";
import RejectPopup from "../RejectPopup";
import AcceptPopup from "../AcceptPopup";
import { EnableAddRequestAction } from "../../../../../../../store/Onboarding/Action";
import { AddMenuHeadingAction } from "../../../../../../../store/Menu/Action";
import history from "../../../../../../../history";
import { addSessionData } from "../../../../../Base/helper/baseHelper";
import OfferLetterResponseStepper from "../../../../../ATSSettings/views/OfferLetter/OfferLetterResponseStepper";
import { getUserData } from "../../../../../Base/helper/baseFunctions";
import "../../../../css/styles.css"
import Draggable from 'react-draggable';
import SelectableSearch from "../../../../../Base/views/SelectableSearch";
import { fnGetAvailableJobMprHelper } from "../../../../helper/AtsMprRequestHelper";
import { GetAtsCandidateHelper } from "../../../../helper/AtsCandidateHelper";

const useStyles = makeStyles((theme) =>
  createStyles({
    ListGrid: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      overflow: "auto",
      marginBottom: "5px",
    },
  })
);
const Loader = () => {
  const classes = useStyles();
  return (
    <div className={classes?.ListGrid}>
      {Array(5)
        .fill()
        .map((data, index) => (
          <div key={index} style={{ padding: "10px" }}>
            <Skeleton variant="text" width={210} sx={{ fontSize: "1rem" }} />
            {Array(5)
              .fill()
              .map((d, i) => (
                <div key={i} style={{ paddingTop: "10px" }}>
                  <Skeleton variant="rounded" width={210} height={70} />
                </div>
              ))}
          </div>
        ))}
    </div>
  );
};
function KanbanBoard({
  currentMode,
  currentJobData,
  candidatevalueData,
  setCandidateUpdate,
  candidateUpdate,
  setCandidatePreview,
  toggleDrawer,
  setAnchor,
  anchor,
  setCurrentData,
  currentData,
  filters,
  sortValue,
  searchVisible,
  tabValue,
  aiConfigPopupRef,
  calendarAccess,
  setAccessGranted,
}) {
  const classes = useStyles();
  const userData = getUserData();
  const dispatch = useDispatch();
  const { fixedMenu, isMobile } = useSelector((state) => state?.MenuReducer);
  const { atsCandidateData } = useSelector(
    (state) => state.AtsReducer?.AtsCandidateReducer
  );
  const [searchTerm, setSearchTerm] = useState("");
  const date = new Date();
  const default_date = `${date?.getFullYear() +
    "-" +
    ("0" + (date?.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + date?.getDate()).slice(-2)
    }`;
  const [elements, setElements] = useState([]);
  const [atsJobStageData, setAtsJobStageData] = useState([]);
  const [atsJobStageData1, setAtsJobStageData1] = useState([]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [offerWarning, setOfferWarning] = useState(false);
  const [stageDeleteConfirm, setStageDeleteConfirm] = useState({ show: false });
  const [inputData, setInputData] = useState({ user: "", note: "" });
  const [dragResult, setDragResult] = useState(false);
  const [load, setLoad] = useState(true);
  const [indexValue, setIndexValue] = useState("");
  const [errors, setErrors] = useState({});
  const [reject, setReject] = useState(false);
  const [accept, setAccept] = useState(false);
  const [stagesData, setStagesData] = useState({ load: true, values: [] });
  const [isverified, setIsVerified] = useState(false);
  const [showValidate, setShowValidate] = useState(false);
  const [popMsg, setPopMsg] = useState("");
  const [isonboard, setIsOnboard] = useState(false);
  const [isoffer, setIsOffer] = useState(false);
  const [isofferform, setIsOfferForm] = useState(false);
  const [message, setMessage] = useState(
    "Do you want to onboard candidate now?"
  );
  const [show, setShow] = useState("1");
  const [offerdata] = useState([]);
  const boardRef = useRef(null);
  const isMprReplacement = !!(inputData?.mpr_info?.hiring_type === "Replacement");
  useEffect(() => {
    GetAtsJobStageHelper({
      ats_jobpost_id: currentJobData?.ats_jobpost_id,
    }).then((res) => {
      if(res?.data?.statuscode === 200){
        setAtsJobStageData(res?.data?.data);
        setAtsJobStageData1(res?.data?.data);
      }
    });
    dispatch(GetAtsCandidateAction());
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (candidateUpdate === true) {
      GetAtsJobStageHelper({
        ats_jobpost_id: currentJobData?.ats_jobpost_id,
      }).then((res) => {
        if(res?.data?.statuscode === 200){
          setAtsJobStageData(res?.data?.data);
          setAtsJobStageData1(res?.data?.data);
        }
      });
      getKanbanData();
      dispatch(GetAtsCandidateAction());
      setCurrentData(candidatevalueData);
      setCandidateUpdate(false);
    }
    // eslint-disable-next-line
  }, [candidateUpdate]);
  useEffect(() => {
    if (
      filters?.assignee_filter?.length > 0 ||
      filters?.proposed_filter?.length > 0 ||
      (filters?.stage_filter && filters.stage_filter.ats_job_stages_id) ||
      sortValue?.name === "priority"
    ) {
      let precruiter = [];
      let propose = [];
      filters?.assignee_filter?.forEach((res) =>
        precruiter.push(res?.recruiter_id)
      );
      filters?.proposed_filter?.forEach((res) =>
        propose.push(res?.recruiter_id)
      );
      const assigned_to_id =
        filters?.assignee_filter?.length > 0
          ? construcData(
            filters?.assignee_filter,
            "assigned_to_id",
            "recruiter_id"
          )
          : null;
      const proposed_by_name =
        filters?.proposed_filter?.length > 0
          ? construcData(
            filters?.proposed_filter,
            "proposed_by_name",
            "proposed_by_name"
          )
          : null;
      const stage_id =
        filters?.stage_filter && filters.stage_filter.ats_job_stages_id
          ? JSON.stringify(
            [{ stage_id: filters.stage_filter.ats_job_stages_id }])
          : null;

      if (currentJobData?.offer_letter) {
        GetAtsJobKanbanOfferHelper({
          ats_jobpost_id: currentJobData?.ats_jobpost_id,
          assigned_to_id: assigned_to_id,
          proposed_by_name: proposed_by_name,
          ats_job_stages_id: stage_id,
          sort_order: sortValue?.order,
        }).then((res) => {
          res?.data?.statuscode === 200 && setElements(res?.data?.data);
          setLoad(false);
        });
      } else {
        GetAtsJobKanbanHelper({
          ats_jobpost_id: currentJobData?.ats_jobpost_id,
          assigned_to_id: assigned_to_id,
          proposed_by_name: proposed_by_name,
          ats_job_stages_id: stage_id,
          sort_order: sortValue?.order,
        }).then((res) => {
          res?.data?.statuscode === 200 && setElements(res?.data?.data);
          setLoad(false);
        });
      }
    } else {
      getKanbanData();
    }
    // eslint-disable-next-line
  }, [filters, sortValue]);

  const construcData = (value, label, key) => {
    var temp = [];
    value?.forEach((res) => {
      temp.push({ [label]: res[key] });
    });
    return JSON.stringify(temp);
  };
  const getKanbanData = () => {
    if (currentJobData?.offer_letter) {
      GetAtsJobKanbanOfferHelper({
        ats_jobpost_id: currentJobData?.ats_jobpost_id,
      }).then((res) => {
        res?.data?.statuscode === 200 && setElements(res?.data?.data);
        setLoad(false);
      });
    } else {
      GetAtsJobKanbanHelper({
        ats_jobpost_id: currentJobData?.ats_jobpost_id,
      }).then((res) => {
        res?.data?.statuscode === 200 && setElements(res?.data?.data);
        setLoad(false);
      });
    }
  };

  const onDragEnd = (result) => {
    if (inputData?.proposeCandidate) {
      if (currentJobData?.offer_letter) {
        AddAtsJobKanbanOfferHelper({
          kanban_data: JSON.stringify([
            {
              proposed_by: userData?.ats_user_id,
              candidate_id: inputData?.user?.candidate_id,
              ats_jobpost_id: currentJobData?.ats_jobpost_id,
              comment: inputData?.note,
              ats_job_stages_id: inputData?.jobStage_id || null,
              priority: 5,
              ats_status_id: null,
              mpr_requests_fk: null
            },
          ]),
        }).then((res) => {
          if (res?.hasError) {
            setInputData({});
          } else {
            res?.data?.statuscode === 200 && setElements(res?.data?.data);
            setInputData({});
            if (res?.data?.statuscode === 200) {
              const kanbanUserData = res?.data?.data?.find(
                (item) => item?.candidate_id === inputData?.user?.candidate_id
              );
              dispatch(
                ProposeCandidateConfirmationAction({
                  candidate_data: inputData?.user,
                  job_data: currentJobData,
                  kanban_data: kanbanUserData,
                })
              );
            }
          }
        });
      } else {
        AddAtsJobKanbanHelper({
          kanban_data: JSON.stringify([
            {
              proposed_by: userData?.ats_user_id,
              candidate_id: inputData?.user?.candidate_id,
              ats_jobpost_id: currentJobData?.ats_jobpost_id,
              comment: inputData?.note,
              ats_job_stages_id: inputData?.jobStage_id || null,
              priority: 5,
              ats_status_id: null,
              mpr_requests_fk: null
            },
          ]),
        }).then((res) => {
          if (res?.hasError) {
            setInputData({});
          } else {
            res?.data?.statuscode === 200 && setElements(res?.data?.data);
            setInputData({});
            if (res?.data?.statuscode === 200) {
              const kanbanUserData = res?.data?.data?.find(
                (item) => item?.candidate_id === inputData?.user?.candidate_id
              );
              dispatch(
                ProposeCandidateConfirmationAction({
                  candidate_data: inputData?.user,
                  job_data: currentJobData,
                  kanban_data: kanbanUserData,
                })
              );
            }
          }
        });
      }
    } else {
      if (!result.destination) {
        return;
      }
      if (currentJobData?.offer_letter) {
        let isJoinedStage = atsJobStageData?.find((x) => +x?.ats_job_stages_id === +result?.destination?.droppableId)?.name === "Joined";
        UpdateAtsJobKanbanOfferHelper({
          kanban_data: JSON.stringify([
            {
              proposed_by: +currentData?.proposed_by,
              candidate_job_id: +result?.draggableId,
              ats_jobpost_id: currentJobData?.ats_jobpost_id,
              interview_feedback: inputData?.note,
              ats_job_stages_id: result?.destination?.droppableId,
              priority: currentData?.priority || 5,
              ats_status_id: null,
              selected: currentJobData?.selected || null,
              candidate_id: elements?.filter(
                (a) => +a?.candidate_job_id === +result?.draggableId
              )?.[0]?.candidate_id,
              accepted_ctc: inputData?.accepted_ctc || currentData?.accepted_ctc || 0,
              assignee_id: elements?.filter(
                (a) => +a?.candidate_job_id === +result?.draggableId
              )?.[0]?.assignee_id,
              tentative_joining_date: inputData?.tentative_joining_date || currentData?.tentative_joining_date || null,
              joined_ctc: inputData?.joined_ctc ? inputData?.joined_ctc : 0,
              joined_date: inputData?.joined_date || null,
              offer_released_date: inputData?.offer_released_date || currentData?.offer_released_date || default_date,
              rejected_reason: inputData?.reason || currentData?.rejected_reason || null,
              reverting_reason: inputData?.revert_reason || currentData?.revert_reason || null,
              job_designation: inputData?.job_designation || null,
              job_location: inputData?.job_location || null,
              mpr_requests_fk: isJoinedStage ? inputData?.mpr_info?.mpr_id || null : null,
              replacement_employee_fk: isJoinedStage ? inputData?.replacement_employee_fk?.candidate_id || null : null,
              replacement_ctc: isJoinedStage ? inputData?.replacement_ctc || null : null,
              replacement_target_date: isJoinedStage ? inputData?.replacement_target_date || null : null,
              primary_approver_status: currentData?.primary_approver_status,
              secondary_approver_status: currentData?.secondary_approver_status,
              interview_date: inputData?.interview_date || null,
            },
          ]),
        }).then((res) => {
          setAccept(false);
          setErrors([]);
          res?.data?.statuscode === 200 && setElements(res?.data?.data);
          setOpenConfirm(false);
          setInputData({ user: "", note: "" });
          if (indexValue === "joined") {
            if (currentData?.access_onboard_candidate) {
              setCurrentData(res?.data?.data?.find((x) => x?.candidate_job_id === currentData?.candidate_job_id));
              setIsOnboard(true);
            } else if (indexValue === "Offer Preparation") {
              setIsOffer(true);
            }
          }
        });
      } else {
         let isJoinedStage = atsJobStageData?.find((x) => +x?.ats_job_stages_id === +result?.destination?.droppableId)?.name === "Joined";
        UpdateAtsJobKanbanHelper({
          kanban_data: JSON.stringify([
            {
              proposed_by: +currentData?.proposed_by,
              candidate_job_id: +result?.draggableId,
              ats_jobpost_id: currentJobData?.ats_jobpost_id,
              interview_feedback: inputData?.note,
              ats_job_stages_id: result?.destination?.droppableId,
              priority: currentData?.priority || 5,
              ats_status_id: null,
              selected: currentJobData?.selected || null,
              candidate_id: elements?.filter(
                (a) => +a?.candidate_job_id === +result?.draggableId
              )?.[0]?.candidate_id,
              accepted_ctc: inputData?.accepted_ctc || currentData?.accepted_ctc || 0,
              assignee_id: elements?.filter(
                (a) => +a?.candidate_job_id === +result?.draggableId
              )?.[0]?.assignee_id,
              tentative_joining_date: inputData?.tentative_joining_date || currentData?.tentative_joining_date || null,
              joined_ctc: inputData?.joined_ctc ? inputData?.joined_ctc : 0,
              joined_date: inputData?.joined_date || null,
              offer_released_date: inputData?.offer_released_date || currentData?.offer_released_date || default_date,
              rejected_reason: inputData?.reason || currentData?.rejected_reason || null,
              reverting_reason: inputData?.revert_reason || currentData?.revert_reason || null,
              job_designation: inputData?.job_designation || null,
              job_location: inputData?.job_location || null,
              mpr_requests_fk: isJoinedStage ? inputData?.mpr_info?.mpr_id || null : null,
              replacement_employee_fk: isJoinedStage ? inputData?.replacement_employee_fk?.candidate_id || null : null,
              replacement_ctc: isJoinedStage ? inputData?.replacement_ctc || null : null,
              replacement_target_date: isJoinedStage ? inputData?.replacement_target_date || null : null,
              interview_date: inputData?.interview_date || null,
            },
          ]),
        }).then((res) => {
          setAccept(false);
          setErrors([]);
          res?.data?.statuscode === 200 && setElements(res?.data?.data);
          setOpenConfirm(false);
          setInputData({ user: "", note: "" });
          if (indexValue === "joined") {
            if (currentData?.access_onboard_candidate) {
              setCurrentData(res?.data?.data?.find((x) => x?.candidate_job_id === currentData?.candidate_job_id));
              setIsOnboard(true);
            } else if (indexValue === "Offer Preparation") {
              setIsOffer(true);
            }
          }
        });
      }
      const listCopy = elements;
      var foundIndex = listCopy?.findIndex(
        (x) => +x.candidate_job_id === +result?.draggableId
      );
      listCopy[foundIndex]["ats_job_stages_id"] =
        +result?.destination?.droppableId;
      setElements([...listCopy]);
    }
  };

  const val = (result, currentData) => {
    var i = result?.destination?.droppableId;
    let currentStg = atsJobStageData?.find((obj) => obj.ats_job_stages_id === i);
    let index = atsJobStageData?.findIndex((obj) => obj.ats_job_stages_id === i);
    if (index === atsJobStageData?.length - 1) {
      const mprInfo = currentData?.mpr_info;
      let repDetails = [];
      if (typeof mprInfo?.replacement_details === "string") {
        try { repDetails = JSON.parse(mprInfo.replacement_details) || []; } catch (e) {}
      } else if (Array.isArray(mprInfo?.replacement_details)) {
        repDetails = mprInfo.replacement_details;
      }
      let alreadyReplaced = [];
      if (Array.isArray(mprInfo?.mpr_jobpost_replacement_details)) {
        mprInfo.mpr_jobpost_replacement_details.forEach((rep) => {
          if (rep?.replacement_employee_name && (!currentData?.candidate_job_id || +rep?.candidate_job_pk !== +currentData?.candidate_job_id)) {
            alreadyReplaced.push(rep.replacement_employee_name.trim().toLowerCase());
          }
        });
      }
      if (Array.isArray(elements)) {
        elements.forEach((el) => {
          if (el?.replacement_employee_name && (!currentData?.candidate_job_id || +el?.candidate_job_id !== +currentData?.candidate_job_id) && (+el?.mpr_requests_fk === +(mprInfo?.mpr_id || mprInfo?.mpr_requests_pk))) {
            alreadyReplaced.push(el.replacement_employee_name.trim().toLowerCase());
          }
        });
      }

      let autoName = mprInfo?.replacement_employee_name || "";
      let autoDesignation = mprInfo?.replacement_employee_designation || "";
      let autoCtc = mprInfo?.replacement_ctc || "";
      if (mprInfo?.hiring_type === "Replacement" && repDetails?.length > 0 && !autoName) {
        const availableOpt = repDetails.find((r) => !alreadyReplaced.includes((r.name || r.full_name || "").trim().toLowerCase())) || repDetails[0];
        autoName = availableOpt?.name || availableOpt?.full_name || "";
        autoDesignation = availableOpt?.designation || "";
        autoCtc = availableOpt?.ctc || "";
      }
      setInputData({
        ...inputData,
        joined_ctc: currentData?.accepted_ctc,
        joined_date: "dd/mm/yyyy",
        mpr_info: mprInfo?.mpr_requests_pk ? {
          ...mprInfo,
          mpr_id: mprInfo?.mpr_requests_pk ,
        } : "",
        replacement_employee_name: autoName,
        replacement_employee_designation: autoDesignation,
        replacement_ctc: autoCtc,
      });
      setIndexValue(() => "joined");
    } else if (index === atsJobStageData?.length - 2) {
      setInputData({
        ...inputData,
        accepted_ctc: "",
        tentative_joining_date: "dd/mm/yyyy",
      });
      setIndexValue("offerAccepted");
    } else if (index === atsJobStageData?.length - 4) {
      setInputData({
        ...inputData,
        offer_released_date: default_date,
      });
      setIndexValue("offerReleased");
    } else if (index === atsJobStageData?.length - 3) {
      setIndexValue("offerRejected");
    } else if (currentStg?.name === "Rejected") {
      setIndexValue("rejected");
    } else {
      setIndexValue("")
    }
  };

  const onDragEndConfirm = (result) => {
    var ele = elements?.find((x) => x?.candidate_job_id === result?.draggableId);
    val(result, ele);
    if ( // if not-verified candidate don't all to drag stage
      elements?.find(
        (x) =>
          x?.candidate_job_id === result?.draggableId &&
          x?.is_verified === false
      )
    ) {
      setCurrentData(
        elements?.find((x) => x?.candidate_job_id === result?.draggableId)
      );
    } else {
      setDragResult(result);
      setCurrentData(
        elements?.find((x) => x?.candidate_job_id === result?.draggableId)
      );
      var rejId = atsJobStageData?.find((obj) => obj.name === "Rejected");
      if (result?.destination?.droppableId === rejId.ats_job_stages_id) {
        setReject(true);
        setInputData({ ...inputData, reason: "" });
      } else if (
        result?.destination?.droppableId !== rejId.ats_job_stages_id &&
        result?.source?.droppableId === rejId.ats_job_stages_id
      ) {
        const relevantStages = [
          "Offer Released",
          "Offer Rejected",
          "Offer Accepted",
          "Joined",
        ];
        const newStage = atsJobStageData?.find(
          (obj) => obj.ats_job_stages_id === result?.destination?.droppableId
        );
        if (
          ele?.offer_letter &&
          !ele?.offer_preparation_completed
        ) {
          if (newStage && relevantStages?.includes(newStage.name)) {
            setOfferWarning(true);
          }
          else {
            setAccept(true);
          }
        }
        else {
          setAccept(true);
        }
        setInputData({ ...inputData, revert_reason: "" });
      } else {
        if (result?.destination?.droppableId !== result.source.droppableId) {
          setPopMsg("");
          const relevantStages = [
            "Offer Released",
            "Offer Rejected",
            "Offer Accepted",
            "Joined",
          ];
          const newStage = atsJobStageData?.find(
            (obj) => obj.ats_job_stages_id === result?.destination?.droppableId
          );
          if (
            ele?.offer_letter &&
            !ele?.offer_preparation_completed
          ) {
            if (newStage && relevantStages.includes(newStage.name)) {
              setOfferWarning(true);
            } else {
              setOpenConfirm(true);
            }
          } else {
            setOpenConfirm(true);
          }
        }
      }
    }
  };
  const handleInputChange = (e, value) => {
    if (value) {
      setInputData({ ...inputData, user: value });
    } else {
      setInputData({ ...inputData, user: "" });
    }
  };

  const validate = (inputData) => {
    let temp = { ...errors };
    if ("joined_date" in inputData) {
      temp.joined_date =
        inputData.joined_date !== "dd/mm/yyyy" ? "" : "Join date is required";
    }
    if ("tentative_joining_date" in inputData) {
      temp.tentative_joining_date =
        inputData.tentative_joining_date !== "dd/mm/yyyy"
          ? ""
          : "Tentative joning date is required";
    }
    if ("reason" in inputData) {
      temp.reason = inputData?.reason === "" ? "Reason is required" : "";
    }
    if ("revert_reason" in inputData) {
      temp.revert_reason =
        inputData?.revert_reason === "" ? "Revert Reason is required" : "";
    }
    if ("stage_id" in inputData) {
      temp.stage_id = ["", null].includes(inputData?.stage_id)
        ? "Moving Stage is required"
        : "";
    }
    setErrors({
      ...temp,
    });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = () => {
    let err = validate(inputData);
    if (err) {
      setReject(false);
      onDragEnd(dragResult);
      setInputData({ user: "", note: "" });
      setIndexValue("");
      setErrors({});
      setOpenConfirm(false);
    }
  };
  const handleStageChange = (event, id) => {
    let dt = atsJobStageData?.findIndex((res) => res?.ats_job_stages_id === id);
    let data = [...atsJobStageData];
    data[dt] = { ...data[dt], name: event.target.value, focus: true };
    setAtsJobStageData(data);
  };
  const handleFieldChange = (event, value) => {
    if (["stage_id"].includes(event)) {
      setInputData({ ...inputData, [event]: value });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...value, [event]: value });
    } else if (event === "mpr_info") {
      if (value) {
        let repDetails = [];
        if (typeof value?.replacement_details === "string") {
          try { repDetails = JSON.parse(value.replacement_details) || []; } catch (e) {}
        } else if (Array.isArray(value?.replacement_details)) {
          repDetails = value.replacement_details;
        }
        let alreadyReplaced = [];
        if (Array.isArray(value?.mpr_jobpost_replacement_details)) {
          value.mpr_jobpost_replacement_details.forEach((rep) => {
            if (rep?.replacement_employee_name && (!currentData?.candidate_job_id || +rep?.candidate_job_pk !== +currentData?.candidate_job_id)) {
              alreadyReplaced.push(rep.replacement_employee_name.trim().toLowerCase());
            }
          });
        }
        if (Array.isArray(elements)) {
          elements.forEach((el) => {
            if (el?.replacement_employee_name && (!currentData?.candidate_job_id || +el?.candidate_job_id !== +currentData?.candidate_job_id) && (+el?.mpr_requests_fk === +(value?.mpr_id || value?.mpr_requests_pk))) {
              alreadyReplaced.push(el.replacement_employee_name.trim().toLowerCase());
            }
          });
        }
        let autoName = "";
        let autoDesignation = "";
        let autoCtc = "";
        if (value?.hiring_type === "Replacement" && repDetails?.length > 0) {
          const availableOpt = repDetails.find((r) => !alreadyReplaced.includes((r.name || r.full_name || "").trim().toLowerCase())) || repDetails[0];
          autoName = availableOpt?.name || availableOpt?.full_name || "";
          autoDesignation = availableOpt?.designation || "";
          autoCtc = availableOpt?.ctc || "";
        }
        setInputData({
          ...inputData,
          mpr_info: value,
          ...(value?.hiring_type === "Replacement" ? {
            replacement_employee_name: autoName,
            replacement_employee_designation: autoDesignation,
            replacement_ctc: autoCtc,
          } : {}),
        });
      } else {
        setInputData({ ...inputData, mpr_info: "", replacement_employee_name: "", replacement_employee_designation: "", replacement_ctc: "" });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ [event]: value ? value : "" });
    } else if (event.target?.name === "accepted_ctc") {
      setInputData({ ...inputData, [event.target.name]: event.target.value });
    } else if (event.target?.name) {
      setInputData({ ...inputData, [event.target.name]: event.target.value });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...inputData, [event.target.name]: event.target.value });
    } else {
      setInputData({ ...inputData, [event.target.name]: event.target.value });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...inputData, [event.target.name]: event.target.value });
    }
  };

  const handleStoreStage = (e, id) => {
    let oldStage = atsJobStageData1.findIndex(
      (res) => res?.ats_job_stages_id === id
    );
    let dt = atsJobStageData?.findIndex((res) => res?.ats_job_stages_id === id);
    let name = atsJobStageData[dt]?.name;
    let sort_key = atsJobStageData[+dt - 1]?.sort_key;
    if ([0].includes(id)) {
      AddAtsJobStageHelper({
        ats_jobpost_id: currentJobData?.ats_jobpost_id,
        name: name,
        indexKey: sort_key,
      })
        .then((res) => {
          if(res?.data?.statuscode === 200){
            toast.dismiss();
            toast.success("Stage added successfully");
            setAtsJobStageData(res?.data?.data);
            setAtsJobStageData1(res?.data?.data);
          }
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(err?.response?.data?.error?.[0]?.message);
          let data = [...atsJobStageData];
          data.splice(dt, 1);
          setAtsJobStageData(data);
          setAtsJobStageData1(data);
        });
    } else {
      if (name !== atsJobStageData1[oldStage]?.name) {
        UpdateAtsJobStageHelper({
          ats_job_stages_id: id,
          ats_jobpost_id: currentJobData?.ats_jobpost_id,
          name: name,
        }).then((res) => {
          if(res?.data?.statuscode === 200){
            setAtsJobStageData1(res?.data?.data);
            setAtsJobStageData(res?.data?.data);
          }
        });
      } else {
        let dt = atsJobStageData?.findIndex(
          (res) => res?.ats_job_stages_id === id
        );
        let data = [...atsJobStageData];
        data[dt] = { ...data[dt], name: name, focus: false };
        setAtsJobStageData(data);
      }
    }
  };

  const handleNewStage = (index, sortKey) => {
    let data = [...atsJobStageData];
    data.splice(index + 1, 0, {
      ats_job_stages_id: 0,
      name: "New Stage",
      sort_key: +sortKey + 0.1,
      focus: true,
    });
    setAtsJobStageData(data);
  };

  const handleProposeCandidate = (value) => {
    if (value?.sort_key === "1") setPopMsg("Select Candidate to Propose");
    setOpenConfirm(true);
    setInputData({
      ...inputData,
      proposeCandidate: true,
      jobStage_id: value?.ats_job_stages_id,
    });
  };

  const handleDeleteStage = (id) => {
    let children = elements?.filter(
      (element) => element.ats_job_stages_id === +id
    );
    if (children?.length > 0) {
      setStageDeleteConfirm({ show: true, jobStage_id: id, stage: "" });
    } else {
      DeleteAtsJobStageHelper({ jobStage_id: id, del_candidates: "N" }).then(
        (res) => {
          if (res?.data?.statuscode === 500) {
            toast.dismiss();
            toast.error(res?.data?.error?.[0]?.message);
          } else {
            setAtsJobStageData(res?.data?.data);
            setAtsJobStageData1(res?.data?.data);
            if (currentJobData?.offer_letter) {
              GetAtsJobKanbanOfferHelper({
                ats_jobpost_id: currentJobData?.ats_jobpost_id,
              }).then((res) => {
                res?.data?.statuscode === 200 && setElements(res?.data?.data);
                setLoad(false);
              });
            } else {
              GetAtsJobKanbanHelper({
                ats_jobpost_id: currentJobData?.ats_jobpost_id,
              }).then((res) => {
                res?.data?.statuscode === 200 && setElements(res?.data?.data);
              });
            }
          }
        }
      );
    }
  };

  const handleStageDelete = () => {
    setStageDeleteConfirm({ show: false, stage: "" });
    DeleteAtsJobStageHelper({
      jobStage_id: stageDeleteConfirm?.jobStage_id,
      del_candidates: stageDeleteConfirm?.stage,
    }).then((res) => {
      if (res?.data?.statuscode === 500) {
        toast.dismiss();
        toast.error(res?.data?.error?.[0]?.message);
      } else {
        setAtsJobStageData(res?.data?.data);
        setAtsJobStageData1(res?.data?.data);
        if (currentJobData?.offer_letter) {
          GetAtsJobKanbanOfferHelper({
            ats_jobpost_id: currentJobData?.ats_jobpost_id,
          }).then((res) => {
            res?.data?.data && setElements(res?.data?.data);
            setLoad(false);
          });
        } else {
          GetAtsJobKanbanHelper({
            ats_jobpost_id: currentJobData?.ats_jobpost_id,
          }).then((res) => {
            res?.data?.statuscode === 200 && setElements(res?.data?.data);
          });
        }
      }
    });
  };

  const filterOptions = (options, { inputValue }) => {
    let vals = matchSorter(options, inputValue, {
      keys: ["first_name", "email_id"],
    });
    vals = vals.map((item) => ({
      ...item,
      full_name: `${item.first_name} ${item.last_name}`,
    }));

    return vals || [];
  };
  const handleVerify = () => {
    setIsVerified(false);
    setShowValidate(true);
  };
  const handleStageDataLoading = () => {
    let filteredData = atsJobStageData;
    if (currentJobData?.offer_letter) {
      if (
        currentData?.job_stage_name === "Offer Preparation" &&
        !currentData?.offer_preparation_completed
      ) {
        // If in "Offer Preparation" stage and not completed, load all stages
        const excludedStages = ["6", "7", "8", "9"];
        filteredData = atsJobStageData?.filter((stage) => {
          return !excludedStages.includes(stage.sort_key);
        });
      } else if (
        currentData?.job_stage_name === "Offer Preparation" ||
        currentData?.job_stage_name === "Offer Released" ||
        currentData?.job_stage_name === "Offer Rejected" ||
        currentData?.job_stage_name === "Offer Accepted" ||
        currentData?.job_stage_name === "Joined"
      ) {
        filteredData = atsJobStageData;
      } else {
        const excludedStages = ["6", "7", "8", "9"];
        filteredData = atsJobStageData?.filter((stage) => {
          return !excludedStages.includes(stage.sort_key);
        });
      }
    }

    setStagesData({ load: false, values: filteredData });
  };
  const handleOnboard = () => {
    dispatch(EnableAddRequestAction({ mode: "add", data: currentData }));
    addSessionData({ key: "selectedMenu", value: "Employee Onboarding" });
    addSessionData({ key: "popup", value: "true" });
    dispatch(AddMenuHeadingAction({ heading: "Employee Onboarding" }));
    history.push("/onboarding");
  };
  const handleLater = () => {
    addSessionData({ key: "popup", value: "true" });
    setShow("2");
    setMessage(
      "You may continue the onboarding process for this candidate by clicking on the same card."
    );
  };
  const handleOffer = () => {
    setIsOffer(false);
    setIsOfferForm(true);
  };
  const [originalElements, setOriginalElements] = useState([]);
  useEffect(() => {
    if (Object.keys(elements).length > 0 && Object.keys(elements).length > Object.keys(originalElements).length) {
      setOriginalElements(elements)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elements])

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (value === "") {
      setElements([...originalElements]);
    } else {
      setElements(
        elements?.filter(
          (element) =>
            element?.full_name?.toLowerCase().includes(value.toLowerCase()) ||
            element?.email_id?.toLowerCase().includes(value.toLowerCase())
        )
      );
    }
  };
  const handleClearSearch = () => {
    setSearchTerm("")
    setElements([...originalElements])
  };

  // dynamic stage column height calculation
  const [maxColumnHeight, setMaxColumnHeight] = useState(0)

  useEffect(() => {
    const maxElementsLength = Math.max(
      0,
      ...atsJobStageData?.map((stage) =>
        elements?.filter(
          (element) => +element?.ats_job_stages_id === +stage?.ats_job_stages_id
        )?.length
      )
    );
    const calculatedHeight = maxElementsLength * 110 + 410;
    setMaxColumnHeight(calculatedHeight);
  }, [atsJobStageData, elements]);


  // Scroll Icon behaviour like jira 
  const handleDrag = (e, data) => {
    if (boardRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = boardRef.current;
      // Maximum scrollable width
      const maxScrollLeft = scrollWidth - clientWidth;
      const scaleFactor = maxScrollLeft / 50;
      const newScrollLeft = Math.min(Math.max(scrollLeft + data.deltaX * scaleFactor, 0), maxScrollLeft);
      boardRef.current.scrollLeft = newScrollLeft;
    }
  };
  const [mprData, setMprData] = useState({
    load: true,
    values: [],
  });
  const [candidateData, setCandidateData] = useState({
      load: true,
      values: [],
    });
  const handleMPROption = () => {
    fnGetAvailableJobMprHelper({ ats_jobpost_fk: currentJobData?.ats_jobpost_id }).then((res) => {
      if (res?.data?.statuscode === 200) {
        const rawMprList = res?.data?.data?.[0]?.fn_get_available_job_mpr || [];
        const formattedList = rawMprList.map((item) => ({
          ...item,
          mpr_display: item?.hiring_type ? `${item.mpr_no} - ${item.hiring_type}` : item.mpr_no,
        }));
        setMprData({ load: false, values: formattedList });
      } else {
        setMprData({ load: false, values: [] });
      }
    })
  }
  const handleCandidateOption = () => {
    GetAtsCandidateHelper().then(res => {
        if (res?.data?.statuscode === 200) {
          const resData = res?.data?.data || [];
          setCandidateData({ load: false, values: resData });
        } else {
          setCandidateData({ load: false, values: [] });
        }
    })
  }
  return (
    <>
      {showValidate && (
        <AtsCandidateValidate
          setOpenValidatePopup={setShowValidate}
          openValidatePopup={showValidate}
          currentData={currentData}
          getKanbanData={getKanbanData}
          kanban={true}
        />
      )}
      {searchVisible && (
        <Box sx={{ display: "flex", color: "rgb(99, 115, 129)", justifyContent: "end", alignItems: "center", padding: "0px 16px" }}>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search by Name or Email"
            value={searchTerm}
            onChange={handleSearchChange}
            sx={{ width: "300px", justifyContent: "end" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="clear search"
                    onClick={handleClearSearch}
                    edge="end"
                    disabled={!searchTerm}
                  >
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>)}
      <Box
        sx={{
          width: isMobile
            ? "100vw"
            : !fixedMenu
              ? "calc(100vw - 65px)"
              : "calc(100vw - 245px)",
          maxWidth: "100%",
          marginRight: !isMobile && "-282px",
          padding: "10px 0px 10px 0px",
          position: "relative",
        }}
      >
        {load ? (
          <Loader />
        ) : (anchor && currentJobData?.is_ai_job) ? (
          <Box>
            <AtsCandidatePreview
              setIsOnboard={setIsOnboard}
              setIsOffer={setIsOffer}
              setIsOfferForm={setIsOfferForm}
              setCandidateUpdate={setCandidateUpdate}
              setCandidatePreview={setCandidatePreview}
              setElements={setElements}
              toggleDrawer={toggleDrawer}
              stageData={atsJobStageData}
              data={currentData}
              currentJobData={currentJobData}
              offerdata={offerdata}
              setCurrentData={setCurrentData}
              tabValue={tabValue}
              isAiJob={currentJobData?.is_ai_job}
              getKanbanData={getKanbanData}
            />
          </Box>
        ) : (
          <>
            <DragDropContext onDragEnd={onDragEndConfirm} >
              <div className={classes?.ListGrid} id="droppable-div" ref={boardRef}>
                {atsJobStageData?.map((listKey, index) => {
                  return (
                    <DraggableElement
                      handleDeleteStage={handleDeleteStage}
                      handleProposeCandidate={handleProposeCandidate}
                      handleStoreStage={handleStoreStage}
                      handleChange={handleStageChange}
                      setCurrentData={setCurrentData}
                      currentData={currentData}
                      setAnchor={setAnchor}
                      setIsVerified={setIsVerified}
                      elements={elements
                        ?.filter((element) => +element?.ats_job_stages_id === +listKey?.ats_job_stages_id)}
                      key={listKey?.ats_job_stages_id}
                      prefix={listKey}
                      getKanbanData={getKanbanData}
                      JobData={currentJobData}
                      stageData={atsJobStageData}
                      handleNewStage={handleNewStage}
                      index={index}
                      stageName={listKey.name}
                      sortKey={listKey.sort_key}
                      currentMode={currentMode}
                      offerdata={offerdata}
                      setElements={setElements}
                      maxColumnHeight={maxColumnHeight}
                      aiConfigPopupRef={aiConfigPopupRef}
                      calendarAccess={calendarAccess}
                      setAccessGranted={setAccessGranted}
                    />
                  );
                })}
              </div>
            </DragDropContext>
            <div
              id="scroll-box-icon-container"
            >
              <div
                style={{
                  display: "flex",
                  position: "absolute",
                  width: "100px",
                  gap: "4px",
                }}
              >
                {Array.from({ length: 5 }).map((_, index) => (
                  <div
                    key={index}
                    id="scroll-box-icon"
                  />
                ))}
              </div>
              <div
                style={{
                  position: "relative",
                  width: "100px",
                }}
              >
                <Draggable
                  axis="x"
                  bounds="parent"
                  onDrag={handleDrag}
                  position={null}
                >
                  <div
                    id="lens-icon-div"
                  />
                </Draggable>
              </div>
            </div>
          </>
        )}
      </Box>
      <Popup
        fullWidth={true}
        maxWidth="md"
        close={false}
        openPopup={(anchor && !currentJobData?.is_ai_job)}
        hideDividers={true}
      >
        <AtsCandidatePreview
          setIsOnboard={setIsOnboard}
          setIsOffer={setIsOffer}
          setIsOfferForm={setIsOfferForm}
          setCandidateUpdate={setCandidateUpdate}
          setCandidatePreview={setCandidatePreview}
          setElements={setElements}
          toggleDrawer={toggleDrawer}
          stageData={atsJobStageData}
          data={currentData}
          currentJobData={currentJobData}
          offerdata={offerdata}
          setCurrentData={setCurrentData}
          tabValue={tabValue}
        />
      </Popup>
      <Popup
        maxWidth="md"
        title={popMsg || "Are you sure want to move candidate?"}
        isMasterProduct={false}
        setOpenPopup={setOpenConfirm}
        openPopup={openConfirm}
        setIndex={setIndexValue}
        setInputData={setInputData}
        setErrors={setErrors}
      >
        <Box minWidth="500px">
          {inputData?.proposeCandidate && (
            <FormControl fullWidth sx={{ pr: 1, mb: 2 }}>
              <Autocomplete
                options={atsCandidateData || []}
                value={inputData?.user}
                size="small"
                name="user"
                filterOptions={filterOptions}
                getOptionLabel={(option) => {
                  if (option && option["first_name"]) {
                    // Concatenate first_name and last_name
                    const fullName = `${option.first_name} ${option.last_name}`;
                    return fullName.trim(); // Trim to remove extra spaces
                  } else {
                    return "";
                  }
                }}
                onChange={handleInputChange}
                renderInput={(params) => (
                  <TextField
                    placeholder="Search candidates by E-mail"
                    {...params}
                    required={true}
                    label="Candidate"
                  />
                )}
              />
            </FormControl>
          )}
          {indexValue === "offerAccepted" && (
            <div>
              <TextField
                sx={{ mb: "15px" }}
                fullWidth
                size="small"
                value={inputData?.accepted_ctc}
                onChange={handleFieldChange}
                variant="outlined"
                id="accepted_ctc"
                label="Accepted CTC"
                name="accepted_ctc"
              ></TextField>
              {
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <CommonDatePicker
                    size="small"
                    required
                    name="tentative_joining_date"
                    label="Tentative Join Date"
                    pickerType="date"
                    onKeyDown={(e) => e.preventDefault()}
                    onKeyPress={(e) => e.preventDefault()}
                    pickerFormat="dd/MM/yyyy"
                    DefaultDTvalue={inputData?.tentative_joining_date}
                    handleChange={(value) =>
                      handleFieldChange({
                        target: {
                          name: "tentative_joining_date",
                          value: value
                            ? `${value?.getFullYear() +
                            "-" +
                            ("0" + (value?.getMonth() + 1)).slice(-2) +
                            "-" +
                            ("0" + value?.getDate()).slice(-2)
                            }`
                            : "",
                        },
                      })
                    }
                    {...(errors.tentative_joining_date && {
                      error: true,
                      helperText: errors.tentative_joining_date,
                    })}
                  />
                </FormControl>
              }
            </div>
          )}
          {indexValue === "joined" && (
            <Box maxWidth={"500px"}>
              <TextField
                sx={{ mb: 2 }}
                fullWidth
                size="small"
                value={currentData?.accepted_ctc}
                disabled={currentData?.accepted_ctc}
                variant="outlined"
                id="accepted_ctc"
                label="Accepted CTC"
                name="accepted_ctc"
              ></TextField>
              <TextField
                sx={{ mb: 2 }}
                fullWidth
                size="small"
                value={inputData?.joined_ctc}
                variant="outlined"
                id="joined_ctc"
                label="Joined CTC"
                name="joined_ctc"
                onChange={handleFieldChange}
              ></TextField>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <CommonDatePicker
                  size="small"
                  required
                  name="joinDate"
                  label="Join Date"
                  pickerType="date"
                  onKeyDown={(e) => e.preventDefault()}
                  onKeyPress={(e) => e.preventDefault()}
                  pickerFormat="dd/MM/yyyy"
                  DefaultDTvalue={inputData?.joined_date}
                  handleChange={(value) =>
                    handleFieldChange({
                      target: {
                        name: "joined_date",
                        value: value
                          ? `${value?.getFullYear() +
                          "-" +
                          ("0" + (value?.getMonth() + 1)).slice(-2) +
                          "-" +
                          ("0" + value?.getDate()).slice(-2)
                          }`
                          : "",
                      },
                    })
                  }
                  {...(errors.joined_date && {
                    error: true,
                    helperText: errors.joined_date,
                  })}
                />
              </FormControl>
              <Box sx={{ ...(inputData?.mpr_info && isMprReplacement && {border: "1px solid #ccc", borderRadius: "4px", p: "10px 4px 0px 4px", mb: "4px"})}}>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <SelectableSearch
                  isOptionEqualToValue={(option, value) =>
                    +option?.mpr_id === +value?.mpr_id
                  }
                  label="MPR"
                  required={false}
                  value={
                    inputData?.mpr_info
                      ? {
                          ...inputData.mpr_info,
                          mpr_display:
                            inputData.mpr_info?.mpr_display ||
                            (inputData.mpr_info?.hiring_type
                              ? `${inputData.mpr_info.mpr_no} - ${inputData.mpr_info.hiring_type}`
                              : inputData.mpr_info.mpr_no),
                        }
                      : null
                  }
                  loading={() => handleMPROption()}
                  fieldLabel="mpr_display"
                  variant={"contained"}
                  name="mpr_info"
                  size="small"
                  data={mprData}
                  onChangeEvent={handleFieldChange}
                  {...(errors.mpr_info && {
                    error: true,
                    helperText: errors.mpr_info,
                  })}
                />
              </FormControl>
              {isMprReplacement && (() => {
                const repOptions = (() => {
                  let repDetails = [];
                  if (typeof inputData?.mpr_info?.replacement_details === "string") {
                    try { repDetails = JSON.parse(inputData.mpr_info.replacement_details) || []; } catch (e) {}
                  } else if (Array.isArray(inputData?.mpr_info?.replacement_details)) {
                    repDetails = inputData.mpr_info.replacement_details;
                  }
                  if (!Array.isArray(repDetails) || repDetails.length === 0) return [];

                  let alreadyReplaced = [];
                  if (Array.isArray(inputData?.mpr_info?.mpr_jobpost_replacement_details)) {
                    inputData.mpr_info.mpr_jobpost_replacement_details.forEach((rep) => {
                      if (rep?.replacement_employee_name && (!currentData?.candidate_job_id || +rep?.candidate_job_pk !== +currentData?.candidate_job_id)) {
                        alreadyReplaced.push(rep.replacement_employee_name.trim().toLowerCase());
                      }
                    });
                  }
                  if (Array.isArray(elements)) {
                    elements.forEach((el) => {
                      if (el?.replacement_employee_name && (!currentData?.candidate_job_id || +el?.candidate_job_id !== +currentData?.candidate_job_id) && (+el?.mpr_requests_fk === +(inputData?.mpr_info?.mpr_id || inputData?.mpr_info?.mpr_requests_pk))) {
                        alreadyReplaced.push(el.replacement_employee_name.trim().toLowerCase());
                      }
                    });
                  }

                  return repDetails.map((item) => {
                    const name = item.name || item.full_name || "";
                    const isReplaced = alreadyReplaced.includes(name.trim().toLowerCase());
                    return {
                      ...item,
                      name: name,
                      designation: item.designation || "",
                      ctc: item.ctc || "",
                      isReplaced: isReplaced,
                    };
                  });
                })();

                const hasDropdown = repOptions.length > 0;

                return (
                  <>
                    {hasDropdown ? (
                      <FormControl fullWidth sx={{ mb: "10px" }} size="small">
                        <InputLabel id="replacement-person-name-label">Replacement Person Name</InputLabel>
                        <Select
                          labelId="replacement-person-name-label"
                          id="replacement_employee_name"
                          name="replacement_employee_name"
                          value={inputData?.replacement_employee_name || ""}
                          label="Replacement Person Name"
                          onChange={(e) => {
                            const selectedName = e.target.value;
                            const matched = repOptions.find((r) => r.name === selectedName);
                            setInputData({
                              ...inputData,
                              replacement_employee_name: selectedName,
                              replacement_employee_designation: matched?.designation || "",
                              replacement_ctc: matched?.ctc || "",
                            });
                          }}
                        >
                          {repOptions.map((opt, idx) => (
                            <MenuItem
                              key={idx}
                              value={opt.name}
                              disabled={opt.isReplaced}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                opacity: opt.isReplaced ? 0.6 : 1,
                              }}
                            >
                              <span>{opt.name}</span>
                              {opt.isReplaced && (
                                <span style={{ color: "#d32f2f", fontSize: "12px", fontWeight: 600, marginLeft: "12px" }}>
                                  - Replaced
                                </span>
                              )}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    ) : (
                      <FormControl fullWidth sx={{ mb: "10px" }}>
                        <TextField
                          size="small"
                          value={inputData?.replacement_employee_name || ""}
                          onChange={handleFieldChange}
                          variant="outlined"
                          fullWidth
                          id="replacement_employee_name"
                          label="Replacement Person Name"
                          name="replacement_employee_name"
                        />
                      </FormControl>
                    )}
                    <FormControl fullWidth sx={{ mb: "10px" }}>
                      <TextField
                        size="small"
                        value={inputData?.replacement_employee_designation || ""}
                        onChange={handleFieldChange}
                        variant="outlined"
                        fullWidth
                        disabled={hasDropdown}
                        id="replacement_employee_designation"
                        label="Current Designation"
                        name="replacement_employee_designation"
                      />
                    </FormControl>
                    <FormControl fullWidth sx={{ mb: "10px" }}>
                      <TextField
                        size="small"
                        type="number"
                        value={inputData?.replacement_ctc || ""}
                        onChange={handleFieldChange}
                        variant="outlined"
                        fullWidth
                        disabled={hasDropdown}
                        id="replacement_ctc"
                        label="Current CTC"
                        name="replacement_ctc"
                      />
                    </FormControl>
                  </>
                );
              })()}
              </Box>
              <FormControl fullWidth>
                <TextField
                  sx={{ mb: "10px" }}
                  size="small"
                  type="text"
                  value={inputData?.job_designation}
                  onChange={handleFieldChange}
                  variant="outlined"
                  fullWidth
                  id="job_designation"
                  label="Designation"
                  name="job_designation"
                />
              </FormControl>
              <FormControl fullWidth>
                <TextField
                  sx={{ mb: "10px" }}
                  size="small"
                  type="text"
                  value={inputData?.job_location}
                  onChange={handleFieldChange}
                  variant="outlined"
                  fullWidth
                  id="job_location"
                  label="Location"
                  name="job_location"
                />
              </FormControl>
            </Box>
          )}
          {indexValue === "offerReleased" && (
            <Box maxWidth={"500px"}>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <CommonDatePicker
                  size="small"
                  name="offer_released_date"
                  label="Offer Released Date"
                  pickerType="date"
                  onKeyDown={(e) => e.preventDefault()}
                  onKeyPress={(e) => e.preventDefault()}
                  pickerFormat="dd/MM/yyyy"
                  DefaultDTvalue={inputData?.offer_released_date}
                  handleChange={(value) =>
                    handleFieldChange({
                      target: {
                        name: "offer_released_date",
                        value: value
                          ? `${value?.getFullYear() +
                          "-" +
                          ("0" + (value?.getMonth() + 1)).slice(-2) +
                          "-" +
                          ("0" + value?.getDate()).slice(-2)
                          }`
                          : "",
                      },
                    })
                  }
                />
              </FormControl>
            </Box>
          )}
          {!["joined","rejected", "offerRejected"].includes(indexValue) && (
            <Box maxWidth={"500px"}>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <CommonDatePicker
                  size="small"
                  name="interview_date"
                  label="Interview Date"
                  pickerType="date"
                  onKeyDown={(e) => e.preventDefault()}
                  onKeyPress={(e) => e.preventDefault()}
                  pickerFormat="dd/MM/yyyy"
                  DefaultDTvalue={inputData?.interview_date || null}
                  handleChange={(value) =>
                    handleFieldChange({
                      target: {
                        name: "interview_date",
                        value: value
                          ? `${value?.getFullYear() +
                          "-" +
                          ("0" + (value?.getMonth() + 1)).slice(-2) +
                          "-" +
                          ("0" + value?.getDate()).slice(-2)
                          }`
                          : "",
                      },
                    })
                  }
                />
              </FormControl>
            </Box>
          )}
          <TextField
            size="small"
            multiline
            rows={4}
            value={inputData?.note}
            onChange={(e) =>
              setInputData({ ...inputData, [e.target.name]: e.target.value })
            }
            variant="outlined"
            fullWidth
            id="note"
            label="Comment"
            name="note"
          />
          <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
            <Button
              sx={{ ml: 2 }}
              disabled={inputData?.proposeCandidate && !inputData?.user}
              variant="outlined"
              className="mpl-primary-btn"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Popup>
      <Popup
        maxWidth="lg"
        title="Are you sure to delete the Stage?"
        isMasterProduct={false}
        setOpenPopup={setStageDeleteConfirm}
        openPopup={stageDeleteConfirm?.show}
      >
        <Box minWidth="400px">
          <FormControl>
            <FormLabel id="gender-label">
              Do you want to delete the candidates
            </FormLabel>
            <FormLabel sx={{ fontSize: "10px" }}>
              (If no candidates will be moved to Default stage)
            </FormLabel>
            <RadioGroup
              onChange={(e) =>
                setStageDeleteConfirm({
                  ...stageDeleteConfirm,
                  stage: e.target.value,
                })
              }
              row
              aria-labelledby="gender-label"
              name="stage"
              value={stageDeleteConfirm?.stage}
            >
              <FormControlLabel value="Y" control={<Radio />} label="Yes" />
              <FormControlLabel value="N" control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>
          <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
            <Button
              disabled={!stageDeleteConfirm?.stage}
              variant="contained"
              className="mpl-primary-btn"
              onClick={() => handleStageDelete()}
            >
              Delete
            </Button>
            <Button
              sx={{ ml: 2 }}
              variant="outlined"
              className="mpl-secondary-btn"
              onClick={() => setStageDeleteConfirm({ show: false, stage: "" })}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Popup>
      <Popup
        maxWidth="lg"
        title="Candidate is not Verified"
        isMasterProduct={false}
        setOpenPopup={setIsVerified}
        openPopup={isverified}
      >
        <Box minWidth="400px">
          <FormControl>
            <FormLabel id="gender-label">
              The Selected Candidate is not Verified
            </FormLabel>
          </FormControl>
          <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="outlined"
              className="mpl-secondary-btn"
              onClick={() => setIsVerified(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{ ml: 2 }}
              className="mpl-primary-btn"
              onClick={() => handleVerify()}
            >
              Verify
            </Button>
          </Box>
        </Box>
      </Popup>

      <RejectPopup
        openPopup={reject}
        setOpenPopup={setReject}
        handleRejectClick={handleSubmit}
        errors={errors}
        setErrors={setErrors}
        setValues={setInputData}
        values={inputData}
      />
      <AcceptPopup
        hide={true}
        accept={accept}
        setAccept={setAccept}
        handleStageDataLoading={handleStageDataLoading}
        handleValues={handleFieldChange}
        errors={errors}
        values={inputData}
        setErrors={setErrors}
        setValues={setInputData}
        handleRejectClick={handleSubmit}
        stagesData={stagesData}
      />
      <Popup
        maxWidth="lg"
        title="Onboard Candidate"
        isMasterProduct={false}
        setOpenPopup={setIsOnboard}
        openPopup={isonboard}
      >
        <Box minWidth="400px">
          <FormControl>
            <FormLabel id="gender-label">{message}</FormLabel>
          </FormControl>
          <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
            {show === "1" && (
              <>
                <Button
                  variant="outlined"
                  className="mpl-secondary-btn"
                  onClick={handleLater}
                >
                  Later
                </Button>
                <Button
                  variant="contained"
                  sx={{ ml: 2 }}
                  className="mpl-primary-btn"
                  onClick={handleOnboard}
                >
                  Yes
                </Button>
              </>
            )}
            {show === "2" && (
              <Button
                variant="contained"
                className="mpl-primary-btn"
                onClick={() => {
                  setIsOnboard(false);
                  setShow("1");
                  setMessage("Do you want to onboard candidate now?");
                }}
              >
                Ok
              </Button>
            )}
          </Box>
        </Box>
      </Popup>

      <Popup
        maxWidth="lg"
        title="Prepare Offer Letter"
        isMasterProduct={false}
        setOpenPopup={setIsOffer}
        openPopup={isoffer}
      >
        <Box minWidth="400px">
          <FormControl>
            <FormLabel id="gender-label">
              Do you want to Prepare the Offer Letter now?
            </FormLabel>
          </FormControl>
          <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
            <span
              style={{
                color: "#1155cc",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => {
                setIsOffer(false);
              }}
            >
              I will do later
            </span>
            <Button
              variant="contained"
              className="mpl-primary-btn"
              onClick={handleOffer}
            // onClick={() => { setIsOffer(false);addSessionData({ key: "offerpopup", value: "true"});}}
            >
              Yes
            </Button>
          </Box>
        </Box>
      </Popup>

      <Popup
        maxWidth="xl"
        title={currentData?.full_name ? `Prepare Offer Letter - ${currentData.full_name}` : "Prepare Offer Letter"}
        fullWidth
        isMasterProduct={true}
        setOpenPopup={setIsOfferForm}
        openPopup={isofferform}
        close={true}
      >
        <OfferLetterResponseStepper
          currentData={currentData}
          currentJobData={currentJobData}
          setIsOfferForm={setIsOfferForm}
          setElements={setElements}
          setCurrentData={setCurrentData}
        />
      </Popup>
      <Popup
        maxWidth="xs"
        title="⚠️ Alert"
        isMasterProduct={true}
        setOpenPopup={setOfferWarning}
        openPopup={offerWarning}
      >
        <Typography sx={{ textAlign: "center", fontSize: "18px" }}>
          Please ensure that you complete the offer generation step to proceed to the Offer Release stage
        </Typography>
      </Popup>
    </>
  );
}
export default KanbanBoard;